import React from 'react';

import type { FC } from 'react';

export const Check: FC<React.SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
      <path d="M6.59812 11.907L3.99563 9.30453C3.70313 9.01203 3.23062 9.01203 2.93812 9.30453C2.64563 9.59703 2.64563 10.0695 2.93812 10.362L6.07312 13.497C6.36562 13.7895 6.83812 13.7895 7.13062 13.497L15.0656 5.56203C15.3581 5.26953 15.3581 4.79703 15.0656 4.50453C14.7731 4.21203 14.3006 4.21203 14.0081 4.50453L6.59812 11.907Z" />
    </svg>
  );
};
